import { ProjectJson } from '@/types';
import { createRandomProject } from './jobs.mock';
import { faker } from '@faker-js/faker';
export const projectsMock: ProjectJson.Project[] = faker.helpers.multiple(
  createRandomProject,
  { count: 10 }
);
